import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import url from "../configs/config";

const VisitorTracker = () => {
  const location = useLocation();

  const getCookieId = () => {
    const name = "visitor_id";
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    if (match) return match[2];

    const newId = "cookie-" + Math.random().toString(36).substring(2, 15);
    document.cookie = `${name}=${newId}; path=/; max-age=${
      60 * 60 * 24 * 365
    };`;
    return newId;
  };

  useEffect(() => {
    const logVisitor = async () => {
      try {
        const today = new Date().toISOString().split("T")[0];
        const currentPath = location.pathname;

        let deviceId = null;

        try {
          const fp = await FingerprintJS.load();
          const result = await fp.get();
          deviceId = result.visitorId;
        } catch (err) {
          console.warn("FingerprintJS failed, using cookie fallback");
        }

        if (!deviceId) {
          deviceId = getCookieId();
        }

        const visits = JSON.parse(localStorage.getItem("visits_log")) || {};
        const visitKey = `${deviceId}_${currentPath}_${today}`;
        if (visits[visitKey]) return;

        await axios.post(`${url.backendURL}visitor`, {
          page: currentPath,
          deviceId,
        });

        visits[visitKey] = true;
        localStorage.setItem("visits_log", JSON.stringify(visits));
      } catch (error) {
        console.error("Error logging visitor:", error);
      }
    };

    logVisitor();
  }, [location.pathname]);

  return null;
};

export default VisitorTracker;
